import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function MediaStream() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Media Stream</span>
                    </div>
                </section>


                <section class="pad bank-benefits default">

                    <div class="content normal">


                        <div class="data margin-top-content">
                            <div class="text">
                                <h3 class="title">News Facebook Pages Owned By Nugenesis</h3>
                                <p class="subtitle">
                                    Nugenesis owned and operated Facebook pages which have been built up by the
                                    nugenesis teams to promote innovative technologies and crypto news

                                </p>

                            </div>
                            <br></br>
                            <div class="text">
                                <h3 class="title">The Crypto Desk</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="https://www.facebook.com/groups/1002693686580466/" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">Inside Crypto</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="https://www.facebook.com/groups/119537788704696/" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">The Crypto Insider</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="https://www.facebook.com/groups/insidecrypto.news/" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">Compare Crypto</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="https://www.facebook.com/groups/comparecrypto/" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>



                        </div>
                        <div class="img-frame img-width40">
                            <div data-lavalamp=""></div>
                            <img src="images/nugenesisou/pr-illustration-23.png" alt="" />
                        </div>
                    </div>

                </section>

                <section class="pad bank-benefits white">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">News Channels Owned By Nugenesis</h3>
                                <p class="subtitle">
                                    With a growing team of journalists, Nugenesis is working on
                                    developing the next chain of leading news channels in the crypto
                                    industry. <br></br><br></br>
                                    Nugenesis owns 4 large Crypto News Websites encompassing the
                                    latest news releases in the Crypto world with great coverage

                                </p>

                            </div>

                            <br></br>
                            <div class="text">
                                <h3 class="title">Inside Crypto News</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="https://www.insidecrypto.news/" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">Comparecrypto News</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="https://comparecrypto.news/" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">Thecryptoinsider News</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="https://thecryptoinsider.news/" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>



                        </div>
                        <div class="img-frame  img-width40">
                            <img src="images/nugenesisou/pr-illustration-24.png" alt="" />
                        </div>
                    </div>

                </section>







                <section class="pad bank-benefits default">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Nugenesis Articles</h3>
                                <p class="subtitle">
                                    Nugeenesis's crypto advancements and involvements in the industry have
                                    not gone unnoticed in the crypto world. Nugenesis has been mentioned in
                                    various articles in regards to the <br></br><br></br>

                                    • Advanced blockchain developments.<br></br>
                                    • Being the up and coming crypto company operating from Australia<br></br>
                                    • Many articles relating to the FTX/Alameda case where Nugenesis had
                                    uncovered prior to their collapse

                                </p>

                            </div>

                        </div>
                        <div class="img-frame">
                            <img src="images/nugenesisou/pr-illustration-25.png" alt="" />
                        </div>
                    </div>
                    <div class="content normal">
                        <div class="data">
                           
                            <div class="text">
                                <h3 class="title">Nugensis FTX articles</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/NuGenesis-FTX-Articles.docx" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">The Merkle articles</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/The-Merkle.docx" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">Inside Crypto articles</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/Inside-Crypto-Articles.docx" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">Mixed Articles</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/Articles.docx" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>

                            <div class="text">
                                <h3 class="title">Coin Telegraph Articles</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/Coin-Telegraph-Articles.docx" target="_blank" data-patt="track-btn" class="">View</a>
                            </div>


                        </div>
                        <div class="img-frame img-width40">
                            <img src="images/nugenesisou/pr-illustration-26.png" alt="" />
                        </div>
                    </div>
                </section>




                <section class="pad bank-benefits white">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Blockchain Development Books</h3>
                                <p class="subtitle">
                                    

                                </p>

                            </div>



                            <div class="text">
                                <h3 class="title">Books written as a result of Nugenesis R&D</h3>
                            </div>

                            <p class="subtitle">
                            Folder Compilation
                            </p>

                            <div class="btns marign-low-bottom-up">
                                <a href="document/The-great-Crypto-Hype-version-2.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>

                            <div class="text">
                            <p class="subtitle">
                            Introduction to blockchain and decentralised ledgering systems.
                            </p>

                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/Introduction-to-blockchain-and-decentralised-ledgering-systems.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>

                            <div class="text">
                            <p class="subtitle">
                            The great Crypto Hype version 2
                            </p>

                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/The-great-Crypto-Hype-version-2.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>

                        </div>
                        <div class="img-frame  img-width40">
                            <img src="images/nugenesisou/pr-illustration-27.png" alt="" />
                        </div>
                    </div>

                </section>

            </main>
            <Footer />
        </>
    )
}